import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { RotatingBadge } from "../components/RotatingBadge";
import { SITE, LOCATIONS } from "../data/site";

export const Hero = () => (
  <section data-testid="hero" className="kremes-texture relative overflow-hidden">
    <div className="mx-auto grid max-w-6xl items-center gap-14 px-5 pb-16 pt-12 sm:pt-16 lg:grid-cols-12 lg:pb-24 lg:pt-20">
      <div className="lg:col-span-7">
        <p
          data-testid="hero-status-badge"
          className="inline-flex items-center gap-2.5 rounded-full border border-goang/30 bg-goang-light px-4 py-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-goang-deep"
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-pulse rounded-full bg-goang" />
          </span>
          Buka Hari Ini · 09.00 – 22.00 WIB
        </p>

        <h1 className="mt-6 font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-charcoal sm:text-5xl lg:text-6xl">
          Ayam goreng{" "}
          <em className="relative inline-block font-heading not-italic text-bumbu">
            basah
            <span aria-hidden="true" className="absolute -bottom-1 left-0 h-[6px] w-full -rotate-1 rounded-full bg-bumbu-bright/50" />
          </em>{" "}
          khas Bandung, juicy sampai suapan terakhir.
        </h1>

        <p className="mt-6 max-w-xl text-base leading-relaxed text-charcoal-muted sm:text-lg">
          Diungkep dalam bumbu kuning sampai gurihnya meresap, digoreng sebentar
          agar tetap basah dan empuk, lalu disajikan panas dengan jukut goreng,
          sambal goang, dan sambal bawang.
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-4">
          <Link
            to="/menu/"
            data-testid="hero-cta-menu"
            className="rounded-full bg-charcoal px-7 py-3.5 font-heading text-sm font-bold text-canvas transition-all hover:scale-[1.03] hover:bg-bumbu hover:text-charcoal active:scale-[0.98]"
          >
            Lihat Menu &amp; Harga
          </Link>
          <a
            href={SITE.grabfood}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-grabfood"
            className="rounded-full border-2 border-charcoal px-7 py-3.5 font-heading text-sm font-bold text-charcoal transition-all hover:scale-[1.03] hover:bg-goang hover:border-goang hover:text-white active:scale-[0.98]"
          >
            Pesan via GrabFood
          </a>
        </div>

        <p className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-xs font-bold uppercase tracking-[0.18em] text-charcoal-muted">
          {LOCATIONS.map((loc) => (
            <span key={loc.id} className="inline-flex items-center gap-1.5">
              <MapPin className="h-3.5 w-3.5 text-bumbu" aria-hidden="true" />
              {loc.name}
            </span>
          ))}
        </p>
      </div>

      <div className="relative lg:col-span-5">
        <div className="relative">
          <img
            src="/images/hero.webp"
            alt="Sepiring ayam goreng berbumbu kuning dengan nasi dan sambal"
            width="1600"
            height="1201"
            fetchpriority="high"
            data-testid="hero-image"
            className="aspect-[4/3] w-full rounded-lg border border-amber-900/15 object-cover shadow-[0_30px_60px_-25px_rgba(120,72,10,0.45)]"
          />
          <div className="px-2">
            <div className="ticket-perf mt-6" aria-hidden="true" />
            <p className="flex items-center justify-between px-2 pt-4 font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-charcoal-muted">
              <span>No. Antrean 076</span>
              <span className="text-bawang">Basah · Juicy · Panas</span>
            </p>
          </div>
        </div>

        <div className="absolute -left-4 -top-6 hidden sm:block lg:-left-10">
          <RotatingBadge />
        </div>

        <div className="absolute -bottom-8 -left-3 w-44 rotate-[-4deg] rounded-lg border border-amber-900/15 bg-white p-3 shadow-xl sm:-left-8 sm:w-52">
          <img
            src="/images/closeup.webp"
            alt="Potongan ayam goreng basah dengan bumbu kuning"
            width="1200"
            height="1803"
            loading="lazy"
            className="aspect-[3/4] w-full rounded object-cover"
          />
          <p className="pt-2 text-center font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-charcoal">
            Bumbu meresap
          </p>
        </div>
      </div>
    </div>
  </section>
);
